import React, { useEffect } from 'react';
import NavBar from '../components/navigation/NavBar';
import CircleBtn from '../components/common/CircleBtn';
import { BtnData, CourseFew, carousel1 } from '../components/common/Data';
import Carousel from '../components/common/Carousel';
import AboutTop from '../components/common/AboutTop';
import ContactHome from '../components/common/ContactHome';
import CourseInfo from '../components/common/CourseInfo';
import style from '../css/Home.module.css';
import { Link } from 'react-router-dom';
import InfoList from '../components/common/InfoList';
import ComInfo from '../components/common/ComInfo';
import Map from '../components/common/Map';
import Footer from '../components/common/Footer';
import Governing from '../components/common/Governing';
import BottomNav from '../components/navigation/BottomNav';

function Home() {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<div>
			<div className="sticky">
				<NavBar />
			</div>
			<Carousel data={carousel1} />
			<CircleBtn data={BtnData} />
			<AboutTop />

			<p className={style.head}>Our Top Courses </p>
			<CourseInfo coursedata={CourseFew} />

			<Governing />

			<ComInfo />

			<div className={style.div1}>
				<p className={style.txt}>
					Ready To Join With Us ! <br /> Let’s Have a Talk.
				</p>
				<Link to={'/About'} className={style.btn1}>
					Wish to know more
				</Link>
			</div>

			<InfoList />
			<Map />
			<Footer />
			<div className="sticky_mob">
				<BottomNav />
			</div>
		</div>
	);
}

export default Home;
